import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const SwayLogoFill32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1920 288q14 0 23 9t9 23v1408q0 14-9 23t-23 9h-896q-14 0-23-9t-9-23V320q0-14 9-23t23-9h896zM874 1194q0 58-17 105t-51 80-79 51-105 18q-57 0-111-15t-98-53q-1-4-2-9t-1-9v-271q19 23 40 48t44 47 51 36 62 15q17 0 28-7t12-26q0-4-1-10t-3-8q-4-16-23-30t-46-31-55-38-54-51-41-71-17-97q0-64 20-114t58-84 90-52 114-18q45 0 78 7t74 25q1 2 3 12t2 12v248q-23-19-42-36t-40-29-43-20-54-7q-17 0-31 10t-14 28q0 16 7 27t18 21 23 16 24 13q40 24 73 50t57 57 37 71 13 89z" />
    </svg>
  ),
  displayName: 'SwayLogoFill32Icon',
});

export default SwayLogoFill32Icon;
